export default __webpack_public_path__ + "static/media/logowhite.6f5d3066.png";